import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { UserRole } from '@/types/menu'

interface ViewRoleState {
  /** 当前视图角色（仅管理员可用），null 表示使用实际角色 */
  viewRole: UserRole | null

  /** 设置视图角色 */
  setViewRole: (role: UserRole | null) => void

  /** 重置为实际角色 */
  resetViewRole: () => void
}

export const useViewRoleStore = create<ViewRoleState>()(
  persist(
    (set) => ({
      viewRole: null,

      setViewRole: (role) => set({ viewRole: role }),

      resetViewRole: () => set({ viewRole: null }),
    }),
    {
      name: 'view-role-storage',
    }
  )
)

/**
 * 角色显示名称映射
 */
export const roleNameMap: Record<UserRole, string> = {
  ADMIN: '管理员',
  CUSTOMER: '客户',
  MARKET: '市场部',
  SERVICE: '客服部',
  ENGINEER: '工程师（上门）',
  LAB_ENGINEER: '实验室工程师',
  FINANCE: '财务部',
  MONTHLY_ADMIN: '月结管理员',
}

/**
 * 获取角色显示名称
 */
export function getRoleName(role: UserRole): string {
  return roleNameMap[role] || role
}
